<template>
  <div class="wrapper">
    <span>{{ text }}</span>
  </div>
</template>
<style scoped>
div.wrapper {
  position: absolute;
  top: 50%;
  bottom: 0px;
  left: 10px;
  /* line-height: 400px; */
  /* writing-mode: vertical-rl; */
  /* text-orientation: sideways-right; */
}
span {
  writing-mode: tb-rl;
  transform: rotate(-180deg);
  font-size: 14px;
  color: #888;
}
</style>
<script>
export default {
  name: "labelVertical",
  props: ["text"],
};
</script>
